import { z } from 'zod';
import { idSchema, isoDateSchema, signedCentsSchema, timestampSchema } from './common.js';
// --- Ingestion des relevés bancaires (lot 7) --------------------------------------------
/** Un gabarit par banque (décision D7) : le parseur déterministe en reconnaît la forme. */
export const BANK_TEMPLATES = ['credit-agricole', 'caixa-geral-depositos'];
export const STATEMENT_STATUSES = ['processed', 'rejected'];
export const bankAccountSchema = z.object({
    id: idSchema,
    label: z.string(),
    iban: z.string(),
    bankTemplate: z.enum(BANK_TEMPLATES),
    currency: z.string(),
    createdAt: timestampSchema,
});
export const statementSchema = z.object({
    id: idSchema,
    bankAccountId: idSchema.nullable(),
    fileName: z.string(),
    sha256: z.string(),
    status: z.enum(STATEMENT_STATUSES),
    rejectionReason: z.string().nullable(),
    periodStart: isoDateSchema.nullable(),
    periodEnd: isoDateSchema.nullable(),
    openingBalanceCents: signedCentsSchema.nullable(),
    closingBalanceCents: signedCentsSchema.nullable(),
    sourcePages: z.number().int().nonnegative().nullable(),
    transactionsCreated: z.number().int().nonnegative(),
    transactionsSkipped: z.number().int().nonnegative(),
    /** Écritures de ce relevé déjà validées (à la main ou par règle) : ce que perdrait son annulation. */
    transactionsValidated: z.number().int().nonnegative(),
    createdAt: timestampSchema,
});
/**
 * Résultat du dépôt d'un fichier : jamais une exception qui arrêterait les autres fichiers
 * du même dépôt multi-fichiers.
 *  - `processed`   : importé, `statement` porte les compteurs.
 *  - `rejected`    : une ligne `statements` existe quand même (traçabilité de la tentative),
 *    `reason` explique pourquoi — gabarit non reconnu, solde non réconcilié, etc.
 *  - `duplicate`   : empreinte SHA-256 déjà connue, rejet immédiat, aucune nouvelle ligne.
 *  - `unreadable`  : le flux s'est interrompu avant même qu'on connaisse le contenu (trop
 *    volumineux, connexion coupée) — pas d'empreinte, donc pas de ligne `statements`.
 */
export const statementDepositOutcomeSchema = z.discriminatedUnion('outcome', [
    z.object({ outcome: z.literal('processed'), fileName: z.string(), statement: statementSchema }),
    z.object({ outcome: z.literal('rejected'), fileName: z.string(), reason: z.string(), statement: statementSchema }),
    z.object({ outcome: z.literal('duplicate'), fileName: z.string(), existingStatementId: idSchema }),
    z.object({ outcome: z.literal('unreadable'), fileName: z.string(), reason: z.string() }),
]);
export const statementDepositResponseSchema = z.object({
    results: z.array(statementDepositOutcomeSchema),
});
/** Annulation d'un import : le relevé et toutes ses écritures disparaissent. */
export const statementCancelResponseSchema = z.object({
    deletedTransactions: z.number().int().nonnegative(),
    deletedValidated: z.number().int().nonnegative(),
});
//# sourceMappingURL=ingestion.js.map